import React, { createContext, useContext, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAllPermissions } from '../store/slices/userSlice';

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [allPermissions, setAllPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasFetched, setHasFetched] = useState(false);

  const fetchPermissions = async () => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      setLoading(true);
      const response = await dispatch(getAllPermissions()).unwrap();
      const permissionsData = Array.isArray(response) ? response : (response?.data ?? response ?? []);
      const permissions = permissionsData.map((perm) => ({
      id: perm.id,
      name: perm.name,
          key: perm.name?.toLowerCase().replace(/\s+/g, '-') || perm.id,
      }));
      setAllPermissions(permissions);
  } catch (err) {
    if (err?.response?.status === 403) {
      setAllPermissions([]); // Just show empty list in Permission Assignment
    } else {
      console.error('Failed to load permissions:', err);
      setAllPermissions([]);
    }
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && !hasFetched) {
      fetchPermissions();
    }
  }, [hasFetched]);

  const refetch = () => {
    setHasFetched(false);
  };

  return (
    <PermissionContext.Provider value={{
      allPermissions,
      loading,
      error,
      refetch,
      fetchPermissions
    }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermissions must be used within PermissionProvider');
  }
  return context;
};